import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import ClosedTaskCardDemo from "../ComponentDemoPage/demos/ClosedTaskCardDemo";
import CompletedTaskCardDemo from "../ComponentDemoPage/demos/CompletedTaskCardDemo";
import LoadingTaskCardDemo from "../ComponentDemoPage/demos/LoadingTaskCardDemo";
import PendingTaskCardDemo from "../ComponentDemoPage/demos/PendingTaskCardDemo";
import RecursiveTextCardFragmentDemo from "../ComponentDemoPage/demos/RecursiveTextCardFragmentDemo";
import styles from "../shared.module.css";

function CardsPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Cards" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "Cards" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          Card Components
        </FixaText>

        <PendingTaskCardDemo />
        <CompletedTaskCardDemo />
        <ClosedTaskCardDemo />
        <LoadingTaskCardDemo />
        <RecursiveTextCardFragmentDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default CardsPage;
